
import { Action } from '@ngrx/store';

import * as PaymentDetailActions from './../actions/payment-details.actions';
import { PaymentDetails } from 'src/app/model/ngrx/payment-details.model';

export type Actions = PaymentDetailActions.Actions;

const initialState: PaymentDetails = {
    sortcode:'',
    accountNumber: '' ,
    bankName: '',
    rollNumber: '',
    accountHolder: '',
    accountType: false
};

// const newState = (state, newData) => {
//     return Object.assign({}, state, newData);
// };

export function paymentDetailsReducer(state: PaymentDetails[] = [initialState], action: PaymentDetailActions.Actions) {
    switch (action.type) {
        case PaymentDetailActions.ADD_PAYMENT_DETAILS:
            return [...state, action.payload];
        // return newState(state, { quoteReferenceNumber: action.payload });

        // Add this case:
        case PaymentDetailActions.REMOVE_PAYMENT_DETAILS:
            state = []; // [...state].splice(action.payload, 1);
            return state;

        default:
            return state;
    }
}
